// src/components/InstallationsChart.js
import React, { useEffect, useState } from "react";
import { getInstallations } from "../api";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function InstallationsChart() {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    getInstallations().then(data => {
      // Sort installations by date
      const sorted = [...data].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );

      const labels = sorted.map(i =>
        new Date(i.date).toLocaleDateString()
      );
      const costs = sorted.map(i => i.cost);

      setChartData({
        labels,
        datasets: [
          {
            label: "Installation Costs",
            data: costs,
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            tension: 0.3,
          },
        ],
      });
    });
  }, []);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Installation Costs Over Time",
      },
    },
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <h2>Installations Chart</h2>
      {chartData && <Line data={chartData} options={options} />}
    </div>
  );
}

export default InstallationsChart;
